import { Box, Tooltip, Typography } from "@mui/material";
import TipoClienteChip from "../../../../components/tipoCliente/TipoClienteChip";

/**
 * Célula de cliente das tabelas da overview: nome + selo PF/PJ ao lado.
 *
 * Recebe o nome e o tipo já resolvidos: o nome vem pronto do backend, conforme
 * a configuração de exibição do nome do cliente.
 *
 * O selo é dimensionado para a densidade do datagrid. A linha é travada em
 * 28px e a célula tem 8px de padding vertical, sobrando 20px de área útil —
 * o selo padrão tem 22px e seria cortado. Cor, raio, peso e caixa continuam
 * vindos do TipoClienteChip, então o padrão visual é o mesmo do resto do
 * sistema; só a altura acompanha o contexto mais denso.
 *
 * O nome encolhe com reticências e o selo não encolhe, para que a
 * identificação PF/PJ nunca seja a parte cortada. Com `tipoCliente` nulo o
 * selo é omitido, em vez de assumir um tipo que ninguém informou.
 */
export default function ClienteComTipo({ nome, tipoCliente }) {
	const nomeExibido = nome || "";

	return (
		<Tooltip title={nomeExibido}>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					gap: 0.75,
					width: "100%",
					minWidth: 0,
				}}
			>
				<Typography
					sx={{
						fontSize: "inherit",
						whiteSpace: "nowrap",
						overflow: "hidden",
						textOverflow: "ellipsis",
						minWidth: 0,
					}}
				>
					{nomeExibido}
				</Typography>

				{tipoCliente !== null && tipoCliente !== undefined && (
					<TipoClienteChip
						tipoCliente={tipoCliente}
						sx={{
							height: 18,
							minWidth: 32,
							fontSize: "0.625rem",
							flexShrink: 0,
							"& .MuiChip-label": { px: 0.75 },
						}}
					/>
				)}
			</Box>
		</Tooltip>
	);
}
